import React, { FC } from 'react';
import { Box, Collapse } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import { ChargeFormEntry } from 'views/orders/charges/components/GeneralChargesTable/types';
import { InvolvedPartyTable } from 'views/orders/charges/components/GeneralChargesTable/components/ChargesTableRow/components/PartiesInvolvedRow/components/InvolvedPartyTable';

const useStyles = makeStyles(() => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    padding: '10px 5px',
  },
}));

type Props = {
  open: boolean;
  charge: ChargeFormEntry;
  onEditParties: (charge: ChargeFormEntry, kind: 'Payee' | 'Payer' | 'Tax') => void;
};

export const PartiesInvolvedSection: FC<Props> = ({ open, charge, onEditParties }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Collapse in={open} timeout="auto" unmountOnExit>
      <Box className={classes.content}>
        {charge.payees.length > 0 && charge.payees.some(({ amount }) => amount > 0) && (
          <InvolvedPartyTable
            parties={charge.payees}
            title={t('orders:payeesLabel')}
            onEditClick={() => onEditParties(charge, 'Payee')}
          />
        )}
        {charge.payers.length > 0 && charge.payers.some(({ amount }) => amount > 0) && (
          <InvolvedPartyTable
            parties={charge.payers}
            title={t('orders:payersLabel')}
            onEditClick={() => onEditParties(charge, 'Payer')}
          />
        )}
        {charge.taxes.length > 0 && charge.taxes.some(({ amount }) => amount > 0) && (
          <InvolvedPartyTable
            parties={charge.taxes}
            title={t('orders:taxesLabel')}
            onEditClick={() => onEditParties(charge, 'Tax')}
          />
        )}
      </Box>
    </Collapse>
  );
};
